import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { createLostTicketFailed, createLostTicketSuccessful } from '../actions';
import { CREATED, OK } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* createLostTicket(action) {
  try {
    const pool = action.payload;

    const url = `${BACKEND_URL}/proxy/tariff/v1/lost-tickets`;
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();

    if (dataResponse.status === CREATED || dataResponse.status === OK) {
      yield put(createLostTicketSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(createLostTicketFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createLostTicketFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
